"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueueName = exports.AlertType = exports.MessageType = void 0;
var MessageType;

(function (MessageType) {
  MessageType["ECOM_CONVERT_QUOTE_TO_ORDER"] = "ECOM_CONVERT_QUOTE_TO_ORDER";
  MessageType["ECOM_ORDER_CREATE"] = "ORDER_CREATE_ECOM";
  MessageType["ECOM_QUOTE_CREATE"] = "ECOM_QUOTE_CREATE";
  MessageType["EMAIL_SEND"] = "EMAIL_SEND";
  MessageType["ERROR_MESSAGE"] = "ERROR_MESSAGE";
  MessageType["IQ_ORDER_UPDATE"] = "ORDER_UPDATE";
  MessageType["IQ_QUOTE_APPROVE"] = "APPROVE QUOTE";
  MessageType["IQ_QUOTE_CREATE"] = "CREATE QUOTE";
  MessageType["IQ_QUOTE_DELETE"] = "DELETE QUOTE";
  MessageType["IQ_QUOTE_UPDATE"] = "UPDATE QUOTE";
  MessageType["SENDGRID_EVENT"] = "SENDGRID_EVENT";
  MessageType["INVOICE_PAYMENT"] = "INVOICE_PAYMENT";
  MessageType["CONTENTFUL_EVENT"] = "CONTENTFUL_EVENT";
  MessageType["MARKETING_CONTENT_EVENT"] = "MARKETING_CONTENT_EVENT";
  MessageType["MARKETING_CONTENT_END_EVENT"] = "MARKETING_CONTENT_END_EVENT";
  MessageType["SUBMIT_CUSTOMER_ONBOARDING"] = "SUBMIT_CUSTOMER_ONBOARDING";
})(MessageType || (exports.MessageType = MessageType = {}));

var AlertType;

(function (AlertType) {
  AlertType["email"] = "email";
  AlertType["text"] = "text";
})(AlertType || (exports.AlertType = AlertType = {}));

var QueueName;

(function (QueueName) {
  QueueName["Communications"] = "Communications";
  QueueName["Quotes"] = "Quotes";
  QueueName["Orders"] = "Orders";
  QueueName["Errors"] = "Errors";
  QueueName["Invoices"] = "Invoices";
  QueueName["Content"] = "Content";
  QueueName["Customer"] = "Customer";
})(QueueName || (exports.QueueName = QueueName = {}));